import React, { useState, useRef } from "react";
import QRCode from "qrcode.react";
import { IoCopyOutline } from "react-icons/io5";
import { MdDone } from "react-icons/md";
import { IoMdClose } from "react-icons/io";
import html2canvas from "html2canvas";
import { FaLink } from "react-icons/fa6";
import { RiDownloadLine } from "react-icons/ri";

const QrCode = ({ link, close }) => {
  const [copyText, setCopyText] = useState(true);
  const [clickDownload, setClickDownload] = useState(false);
  const qrRef = useRef();
  const handleCopy = () => {
    navigator.clipboard.writeText(link);
    setCopyText(false);

    setTimeout(() => setCopyText(true), 3000);
  };
  const handleDownload = () => {
    const qrCodeContainer = qrRef.current;
    html2canvas(qrCodeContainer, { scale: 2 })
      .then(function (canvas) {
        const url = canvas.toDataURL("image/png");
        const link = document.createElement("a");
        link.href = url;
        link.download = "qr_code.png";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch(function (error) {
        console.error("Error generating QR code image:", error);
      });
  };
  return (
    <div className="overlay z-50">
      <div className="modal !w-[430px] !h-[480px] !justify-normal relative ">
        <button
          className="absolute top-0 right-0 pr-3 pt-3 text-xl"
          onClick={close}
        >
          <IoMdClose className="font-bold" />
        </button>
        <div className=" text-sm mt-[44px] font-semibold  flex flex-col items-center  w-full   !mb-0 border-b  border-[#bebebe]">
          <div ref={qrRef} className=" w-full flex justify-center">
            {" "}
            <div className=" flex flex-col">
              <p className=" text-lg font-semibold mb-4">Scan QR Code</p>{" "}
              <QRCode value={link} size={160} className="mb-9" />
            </div>
          </div>
          {!clickDownload && (
            <button
              onClick={handleDownload}
              className=" mb-9 py-[6px] px-4 bg-[#00394d] text-white text-base font-medium flex items-center justify-center"
            >
              {" "}
              <span className="mr-2">
                <RiDownloadLine className="w-[16px] h-[20px]" />
              </span>
              Download
            </button>
          )}
        </div>
        <div className=" flex items-center justify-center mt-10 space-x-1 ">
          <p className=" font-semibold  bg-[#f1f4f5] pr-[6px] py-1 pl-4  rounded mr-[12px] flex items-center">
            <span className=" mr-4 text-[10px] font-medium text-[#6b778e]">
              {link}
            </span>
            <span>
              {" "}
              <div className=" border border-[#cdd1d2] flex px-3 py-1 rounded-lg items-center text-xs bg-white">
                {copyText ? (
                  <>
                    <FaLink
                      className="w-[16px] h-[16px]  cursor-pointer mr-2"
                      onClick={handleCopy}
                    />
                    <p onClick={handleCopy} className="cursor-pointer text-xs">
                      Copy Link
                    </p>
                  </>
                ) : (
                  <>
                    <MdDone className="w-[16px] h-[16px] mr-2" />
                    <p className="text-xs">Link Copied</p>
                  </>
                )}
              </div>
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default QrCode;
